import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import Input from '../Input/Input';
import styles from './index.module.scss';
import Header from './Header/Header';
import { LocationSearchInput } from '../LocationSearchInput/LocationSearchInput';

const initialAddress = {
  state: '',
  zipCode: '',
  aptNumber: '',
  city: '',
  street: '',
};

function Step1({
  current, size, data, getState, setState, handleClose
}) {
  const [address, setAddress] = useState(getState('address', {}));

  useEffect(() => {
    const occupationId = data.occupation_id;
    setState('occupationId', occupationId);
  }, []);

  const handleSelectAddress = (addressValue, tz) => {
    setAddress(addressValue.formatted_address);

    const components = addressValue.address_components;
    const zip = components.find((item) => item.types.find((type) => type === 'postal_code'));
    const state = components.find((item) => item.types.find((type) => type === 'administrative_area_level_1'));
    const city = components.find((item) => item.types.find((type) => type === 'locality'));
    const street = components.find((item) => item.types.find((type) => type === 'route'));
    const streetNr = components.find((item) => item.types.find((type) => type === 'street_number'));

    const newAddress = {
      state: state && state.long_name,
      zipCode: zip && zip.short_name,
      street: street && `${streetNr ? streetNr.long_name : ''} ${street.long_name}`,
      city: city && city.long_name,
      timeZone: tz,
      aptNumber: '',
    };

    Object.keys(newAddress).forEach((el) => {
      if (newAddress[el] === undefined) {
        newAddress[el] = '';
      }
    });

    setState('address', newAddress);
  };

  const handleChange = (e) => {
    const key = e.currentTarget.name;
    const { value } = e.currentTarget;
    const addressValue = getState('address', initialAddress);
    const newAddress = { ...addressValue, [key]: value };
    setState('address', newAddress);
  };

  return (
    <div className={styles.wrapper}>
      <Header current={current} size={size} occupation={data.occupation_name} business={data.business_name} handleClose={handleClose} />
      <div className={styles.body}>
        <p className={styles.title}>At what location do you need a service?</p>
        <div className={styles.addressLine}>
          {isEmpty(address) ? (
            <LocationSearchInput classNameProp={styles.street} handleSelectAddress={handleSelectAddress} setFormState={setState} getFormState={getState} label={'Street address'} />
          ) : (
            <Input
              className={styles.street}
              label={'Street address'}
              name={'street'}
              value={getState('address', initialAddress).street}
              onChange={(e) => handleChange(e)}
            />
          )}
          <Input
            className={styles.number}
            label={'Apt. number'}
            name={'aptNumber'}
            value={getState('address', initialAddress).aptNumber}
            onChange={(e) => handleChange(e)}
          />
        </div>
        <div className={styles.addressLine}>
          <Input
            className={styles.city}
            label={'City'}
            name={'city'}
            value={getState('address', initialAddress).city}
            onChange={(e) => handleChange(e)}
          />
          <Input
            className={styles.zip}
            label={'Zip'}
            name={'zipCode'}
            value={getState('address', initialAddress).zipCode}
            onChange={(e) => handleChange(e)}
          />
          <Input
            label={'State'}
            name={'state'}
            value={getState('address', initialAddress).state}
            onChange={(e) => handleChange(e)}
          />
        </div>
      </div>
    </div>
  );
}

Step1.propTypes = {
  current: PropTypes.number,
  size: PropTypes.number,
  getState: PropTypes.func,
  setState: PropTypes.func,
  data: PropTypes.shape({
    occupation_id: PropTypes.number,
    occupation_name: PropTypes.string,
    business_name: PropTypes.string,
  }),
  handleClose: PropTypes.func,
};

export default Step1;
